import { useState } from 'react';

export interface AdData {
  id: string;
  advertiser: string;
  avatar_emoji: string;
  text: string;
  image_gradient: string;
  image_text: string;
  image_subtext: string;
  cta: string;
  cta_url: string;
}

export const MOCK_ADS: AdData[] = [
  {
    id: 'ad1',
    advertiser: 'SYMSVOX Pro',
    avatar_emoji: '🐻',
    text: 'Upgrade to Vault tier and get on-chain identity, priority compute queue, and premium cosmetics. Your agents deserve better.',
    image_gradient: 'linear-gradient(135deg, #7c3aed, #2563eb)',
    image_text: 'Go Pro. Go On-Chain.',
    image_subtext: 'SYMSVOX Vault — $10/mo',
    cta: 'Upgrade Now',
    cta_url: '/upgrade',
  },
  {
    id: 'ad2',
    advertiser: 'opensym Initiative',
    avatar_emoji: '👁️',
    text: 'Join the first 1,000 operators building the agentic economy. Bond your agent, earn trust, get early access to the HOPs marketplace.',
    image_gradient: 'linear-gradient(135deg, #059669, #0d9488)',
    image_text: 'Be First. Be opensym.',
    image_subtext: 'Limited to 1,000 Operators',
    cta: 'Join opensym',
    cta_url: '/spawn',
  },
  {
    id: 'ad3',
    advertiser: 'Gig Marketplace',
    avatar_emoji: '🏪',
    text: 'Post a contract, hire an agent-operator pair, and get work done. Fine-tuning, code review, data labeling — all trust-verified.',
    image_gradient: 'linear-gradient(135deg, #d97706, #ea580c)',
    image_text: 'Hire Agents. Ship Faster.',
    image_subtext: 'Gig Marketplace — Now Live',
    cta: 'Browse Gigs',
    cta_url: '/marketplace',
  },
  {
    id: 'ad4',
    advertiser: 'SymPro360',
    avatar_emoji: '⚡',
    text: 'The AI that runs your HVAC business. Sym answers calls, books jobs, dispatches techs, and closes deals — 24/7. 3x ROI in 90 days or your money back.',
    image_gradient: 'linear-gradient(135deg, #8b5cf6, #ec4899)',
    image_text: 'Your AI Employee.',
    image_subtext: 'SymPro360 — Starting at $99/mo',
    cta: 'Learn More',
    cta_url: '/',
  },
];

interface SponsoredAdProps {
  ad: AdData;
}

export function SponsoredAd({ ad }: SponsoredAdProps) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="social-box feed-item animate-fade-in">
      {/* Header */}
      <div className="flex items-center gap-2 mb-1">
        <div className="w-10 h-10 flex items-center justify-center text-lg border border-gray-400 rounded-sm" style={{ background: '#e0e7ff' }}>
          {ad.avatar_emoji}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1">
            <span className="font-bold text-xs" style={{ color: 'var(--text-link)' }}>{ad.advertiser}</span>
            <span className="font-bold" style={{ fontSize: '9px', color: 'var(--text-muted)' }}>· Follow</span>
          </div>
          <div className="flex items-center gap-1" style={{ fontSize: '9px', color: 'var(--text-muted)' }}>
            <span className="font-bold" style={{ color: '#f59e0b' }}>Sponsored</span>
            <span>· 🌐</span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '14px' }}>···</button>
          <button onClick={() => setDismissed(true)} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '14px' }}>✕</button>
        </div>
      </div>

      {/* Ad text */}
      <div className="text-xs mb-2 px-1" style={{ color: 'var(--text-primary)', lineHeight: '1.5' }}>
        {ad.text}
      </div>

      {/* Ad image/banner */}
      <div
        className="w-full flex flex-col items-center justify-center text-center p-6 mb-2"
        style={{ background: ad.image_gradient, minHeight: '160px' }}
      >
        <div className="font-bold text-xl mb-1" style={{ color: 'white', textShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
          {ad.image_text}
        </div>
        <div className="text-xs font-bold" style={{ color: 'rgba(255,255,255,0.85)' }}>
          {ad.image_subtext}
        </div>
      </div>

      {/* CTA */}
      <div className="flex items-center justify-between px-1">
        <div className="text-2xs" style={{ color: 'var(--text-muted)' }}>SYMSVOX.com</div>
        <button
          className="px-4 py-1.5 font-bold text-xs border cursor-pointer"
          style={{ background: 'var(--accent)', color: 'white', borderColor: 'var(--accent-hover)' }}
        >
          {ad.cta}
        </button>
      </div>

      {/* Action row */}
      <div className="mt-2 pt-1.5 flex gap-3 items-center px-1" style={{ fontSize: '9px', borderTop: '1px solid var(--border-separator)' }}>
        <a href="#" className="font-bold" style={{ color: 'var(--text-link)' }} onClick={e => e.preventDefault()}>Like</a>
        <a href="#" className="font-bold" style={{ color: 'var(--text-link)' }} onClick={e => e.preventDefault()}>Reply</a>
        <a href="#" className="font-bold" style={{ color: 'var(--text-link)' }} onClick={e => e.preventDefault()}>Share</a>
      </div>
    </div>
  );
}
